"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const h=(e="",c="",p)=>{const[,a]=/\/?app\/([^/]+)/gi.exec(c)||[];let t=e;try{t=new URL(e).pathname}catch{t=e}return!!(a&&p(t,`/app/${a}/:subpath?`))};exports.pathMatchesHeaderLink=h;
//# sourceMappingURL=path-matches-header-link.js.map
